<div>
  <div class="container" style="border: 2px solid black">
    <div class="row">
      <!-- Logo -->
      <div class="col-3">
        <img
          style="margin-top: 8%"
          width="80%"
          src="../../../assets/img/brand/book.png"
        />
      </div>

      <!-- Header -->
      <div
        class="col-7"
        style="padding-top: 30px; text-align: center; padding-bottom: 10px"
      >
        <span style="font-size: 30px; font-weight: bold">
          हिंदुस्थान प्रकाशन संस्था
        </span>
        <span style="font-size: 16px; margin-left: 5px">
          (Reg.No.-BOM-3/1961(GBBSD))
        </span>
        <hr />

        <div class="row" style="text-align: left">
          <!-- Admin Office -->
          <div class="col-6" style="padding-top: 10px">
            <span style="font-size: 14px">
              <span style="font-weight: bold; font-size: 18px">
                प्रशासकीय कार्यालय :<br />
              </span>
              116, 117, 118, 119,<br />
              पहिला मजला, शिल्पीन सेंटर, ग. द. आंबेकर मार्ग,<br />
              वडाळा, मुंबई - 400031<br />
            </span>
            <span style="font-size: 16px">
              <span style="font-weight: bold">दूरध्वनी:</span>
              9967570531
            </span>
          </div>

          <!-- Main Office -->
          <div
            class="col-6"
            style="border-left: 2px solid black; padding-top: 10px"
          >
            <span style="font-size: 14px">
              <span style="font-weight: bold; font-size: 18px">
                मुख्य कार्यालय :<br />
              </span>
              5/12, कामत औद्योगिक वसाहत,<br />
              396 स्वा. वीर सावरकर मार्ग,<br />
              प्रभादेवी, मुंबई 400025.<br />
            </span>
            <span style="font-size: 16px">
              <span style="font-weight: bold">दूरध्वनी :</span>
              24221440
            </span>
          </div>
        </div>
      </div>

      <!-- Receipt Title -->
      <div
        class="col-2"
        style="border-left: 2px solid black; padding-top: 80px; text-align: center"
      >
        <span style="font-size: 24px">
          पुस्तक जमा <br /><br />
          पावती
        </span>
      </div>
    </div>

    <!-- Seller + Receipt Info -->
    <div class="row" style="border-top: 2px solid black">
      <!-- Seller Details -->
      <div class="col-6" style="padding: 20px; text-align: left">
        <span style="font-weight: bold">Book Seller Name: </span>
        {{ bookpymtrcptdata[0]?.receiver_name }}<br />

        <span style="font-weight: bold">Address: </span>
         {{ bookpymtrcptdata[0]?.receiver_address }}<br />

        <span style="font-weight: bold">Mobile No: </span>
        {{ bookpymtrcptdata[0]?.mobile }}
      </div>

      <!-- Receipt Info -->
      <div class="col-6" style="border-left: 2px solid black; padding: 20px">
        <div
          class="row"
          style="border-bottom: 2px solid black; padding-bottom: 10px"
        >
          <div class="col-6">
            <span style="font-weight: bold">पावती क्रं.: </span>
            {{ receiptno }}
          </div>
          <div class="col-6">
            <span style="font-weight: bold">दिनांक: </span>
            {{ data?.recptdate | date: "dd-MM-yyyy" }}
          </div>
        </div>

        <div style="padding-top: 15px">
          <span style="font-weight: bold">यांचेकडुन रुपये </span>
          {{ value }} /-
        </div>

        <div style="text-align: right; font-weight: bold">
          मात्र साभार पोहोचले.
        </div>

        <div style="padding-top: 10px">
          <span style="font-weight: bold">धनादेश क्रं.: </span>
          {{ bookdata?.cheque_no }}
        </div>

        <div>
          <span style="font-weight: bold">दिनांक: </span>
          <span *ngIf="bookdata?.chequeDate === '0000-00-00'">
            {{ bookdata?.chequeDate }}
          </span>
          <span *ngIf="bookdata?.chequeDate !== '0000-00-00'">
            {{ bookdata?.chequeDate | date: "dd-MM-yyyy" }}
          </span>
        </div>

        <div>
          <span style="font-weight: bold">बँक: </span>
          {{ bookdata?.bank }}
        </div>

        <div>
          <span style="font-weight: bold">जमा रक्कम रु. </span>
          {{ value }} /-
        </div>

        <div>
          <span style="font-weight: bold">अक्षरी रक्कम: </span>
          {{ totalinWords }}
        </div>
      </div>
    </div>

    <!-- Invoice / Order Section -->
   
     <div class="row" style="border-top:2px solid black; padding:15px;">
      <div class="col-12">

        <ng-container *ngFor="let book of bookpymtrcptdata">

          <ng-container *ngIf="getDisplayNumber(book) as number">

            <span style="font-weight:bold;">
              {{ number.startsWith('V') ? 'बिल नंबर:' : 'ऑर्डर नंबर:' }}
            </span>

            {{ number }}
            <br />

          </ng-container>

        </ng-container>

      </div>
    </div>

    <!-- Footer -->
    <div
      class="row"
      style="margin-top: 100px; padding: 20px"
    >
      <div class="col-6">
        <span style="font-weight: bold">
          (धनादेश वटल्यावरच पावती अधिकृत होईल)
        </span>
      </div>

      <div class="col-6" style="text-align: right; font-weight: bold">
        व्यवस्थापक / लेखापाल
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <button
    class="noPrint"
    style="margin-top: 2%"
    (click)="save()"
    mat-raised-button
    color="primary"
  >
    Save
  </button>

  <button
    class="noPrint"
    style="margin-top: 2%; margin-left: 10px"
    (click)="print()"
    mat-raised-button
    color="primary"
  >
    Print
  </button>

  <button
    class="noPrint"
    style="margin-top: 2%; margin-left: 10px"
    mat-button
    mat-dialog-close
  >
    Close
  </button>
</div>